// extracted by mini-css-extract-plugin
export var chip = "_p5-0";
export var icon = "_p5-1";
export var remove = "_p5-2";
export var removeIcon = "_p5-3";